/**
 * Footer component.
 * @module components/theme/Footer/Footer
 */

import { getFooterLinks } from '@package/actions';
import Button from '@package/components/Button';
import Icon from '@package/components/Icon';
import SocialLinks from '@package/components/SocialLinks';
import { toBackendLang } from '@plone/volto/helpers/Utils/Utils';
import { useEffect } from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import LogoFooter from '../Logo/LogoFooter';
import { openManageCookies } from 'lgpd.plugin/actions';

const messages = defineMessages({
  copyright: {
    id: 'copyrightMessage',
    defaultMessage:
      '© PORTAL FEDERATIVO 2025 - Content developed by Secretaria de Relações Institucionais',
  },
  manageCookies: {
    id: 'Manage cookies',
    defaultMessage: 'Manage cookies',
  },
});

const FooterLinks = ({ links, lang }) => {
  if (!links?.length) return null;

  return (
    <nav className="links">
      {links.map((link, id) => {
        const { [`url_${lang}`]: url, [`label_${lang}`]: label } = link;

        if (!url || !label) return null;
        return (
          <Button href={url} invert link small key={id}>
            {label}
          </Button>
        );
      })}
    </nav>
  );
};

const Footer = ({ intl }) => {
  const { locale } = intl;
  const lang = toBackendLang(locale);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getFooterLinks());
  }, [dispatch]);
  const result = useSelector((state) => {
    return state.footerLinks;
  });

  return (
    <>
      <footer className="site-footer">
        <div className="content">
          <div className="logo">
            <LogoFooter />
            <div className="social-links">
              <SocialLinks invert />
            </div>
          </div>
          <div className="nav-wrapper">
            <Button
              invert
              onClick={() => {
                dispatch(openManageCookies());
              }}
            >
              <Icon name="cookie" />
              {intl.formatMessage(messages.manageCookies)}
            </Button>
            <nav className="footer-nav">
              <FooterLinks links={result.data} lang={lang} />
            </nav>
          </div>
        </div>
        <div className="copyright">
          {intl.formatMessage(messages.copyright)}
        </div>
      </footer>
    </>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
Footer.propTypes = {
  /**
   * i18n object
   */
};

export default injectIntl(Footer);
